import React from 'react';
import {
  Image as ImageIcon,
  Description as DocumentIcon,
  Code as CodeIcon,
  PictureAsPdf as PdfIcon,
  InsertDriveFile as FileIcon
} from '@mui/icons-material';

/**
 * FileTypeIcon Component
 * Returns appropriate icon based on file type
 */
const FileTypeIcon = ({ fileType, sx = {} }) => {
  const iconProps = {
    sx: { fontSize: 20, ...sx }
  };

  if (!fileType) {
    return <FileIcon {...iconProps} />;
  }

  const type = fileType.toLowerCase();

  if (type.includes('image') || type.includes('png') || type.includes('jpg') || type.includes('jpeg') || type.includes('gif') || type.includes('webp')) {
    return <ImageIcon {...iconProps} />;
  }

  if (type.includes('html') || type.includes('code')) {
    return <CodeIcon {...iconProps} />;
  }

  if (type.includes('pdf')) {
    return <PdfIcon {...iconProps} />;
  }

  if (type.includes('markdown') || type.includes('md') || type.includes('documentation')) {
    return <DocumentIcon {...iconProps} />;
  }

  return <FileIcon {...iconProps} />;
};

export default FileTypeIcon;
